/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 */

import React, { useState, useMemo, useEffect } from 'react';

import SectionTogglePanel from "../../../../common/components/SectionTogglePanel";
import FilterComponentBuilder from "./FilterComponentBuilder";

import { getFilters } from '../utils/FilterUtils';
import { titleCase } from '../utils/titleCase';
import { getGroupIcon } from '../utils/groupIcons';

const FilterSection = (props) => {
    const {
        groupKey,
        subGroupKey = 'DEFAULT',
        title,
        subTitle,
        appearance = 'default',
        filterState,
        handleKeyValueChange,
        metaDataObj,
        handleSubmitFilter,
        handleRemoveFilter,
        searchText,
        productSubscription,
        productKey,
        defaultOpen = false,
    } = props;

    const [isExpanded, setIsExpanded] = useState(defaultOpen);

    // Logic
    const filteredOptions = useMemo(() => {
        const rawOptions = getFilters(groupKey, subGroupKey, productSubscription, productKey);

        if (!searchText) return rawOptions;

        const lowerSearch = searchText.toLowerCase();
        return rawOptions.filter(opt => (
            (opt.label && opt.label.toLowerCase().includes(lowerSearch)) ||
            (opt.id && opt.id.toLowerCase().includes(lowerSearch))
        ));
    }, [groupKey, subGroupKey, searchText, productSubscription, productKey]);

    // Auto-expand
    useEffect(() => {
        if (searchText && filteredOptions.length > 0) {
            setIsExpanded(true);
        } else if (!searchText) {
            setIsExpanded(defaultOpen);
        }
    }, [searchText, filteredOptions.length, defaultOpen]);

    if (!filteredOptions || filteredOptions.length === 0) return null;

    const card = appearance === 'card';

    return (
        <SectionTogglePanel
            key={`${groupKey}_FILTERS`}
            title={card ? titleCase(title) : title}
            subTitle={subTitle}
            appearance={appearance}
            icon={card ? getGroupIcon(groupKey) : undefined}
            isExpand={isExpanded}
            handleOnClick={(value) => setIsExpanded(value)}
        >
            <FilterComponentBuilder
                groupKey={groupKey}
                compact={appearance === 'compact'}
                filterOptions={filteredOptions}
                stateObj={filterState}
                handleKeyValueChange={handleKeyValueChange}
                metaDataObj={metaDataObj}
                handleSubmitFilter={handleSubmitFilter}
                handleRemoveFilter={handleRemoveFilter}
                productSubscription={productSubscription}
            />
        </SectionTogglePanel>
    );
};

export default FilterSection;
